'use strict';

let verification = {
    devUrl: 'qatest',        // 测试环境
    productionUrl: 'www', // 生产环境
    /*初始化*/
    init() {
        this.blurWarn();
        this.comfirmPhone();
        this.commfirmSubmit();
    },
    /*
     * body 滚动条锁定&解锁
     * true: 锁定
     */
    lockScroll(lock = false) {
        if (lock) {
            $('body').addClass('noScroll');
        } else {
            $('body').removeClass('noScroll');
        }
    },
    blurWarn() {
        // 非空校验
        $(document).on('blur', '.form-list input.blur', function() {
            let _val = $(this).val().replace(/\s+/g, '');
            if (!_val) {
                $(this).siblings('.err').show();
                $(this).parents('li').removeClass('active');
            } else {
                $(this).siblings('.err').hide();
                $(this).parents('li').addClass('active');
            }
        })
    },
    // 手机号码正确性校验
    comfirmPhone() {
        //    /^1[34578]\d{9}$/ 手机号码正确性
        $(document).on('blur', '.phone', function() {
            let _val = $(this).val().replace(/\s+/g, ""),
                _state = /^1[34578]\d{9}$/.test(_val);
            if (_val === '') {
                $(this).siblings('.err').html('*联系方式不能为空');
                return
            }
            if (!_state) {
                $(this).siblings('.err').html('*联系方式不正确').show();
                $(this).parents('li').removeClass('active');
            } else {
                $(this).parents('li').addClass('active');
            }
        })
    },
    commfirmSubmit() {
        $(document).on('click', '.form-btn', function() {
            let _target = $(this).siblings('form'),
                _count = _target.find('.form-list li.active').length,
                _maxCount = _target.find('.form-list li').length - 1;
            
            if (_count < _maxCount) {
                _target.find('.form-list li').each(function() {
                    if (!$(this).hasClass('active')) {
                        $(this).find('.err').show();
                    }
                })
            } else {
                verification.submitData(_target);
            }
        })
    },
    submitData(target) {
        let _name = target.find('.name').val(),
            _company = target.find('.companyName').val().replace(/\s+/g, ''),
            _phone = target.find('.phone').val(),
            _city = target.find('.city').val().replace(/\s+/g, ''),
            _email = target.find('.email').val(),
            _state = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g.test(_email),
            _this = this;

        if (_email && !_state) {
            new MsgBox({
                iconCls: 'err',
                msg: "邮箱格式不正确",
                delay: 5
            });
            target.find('.email').focus();
            return;
        }
        $('.form-btn').html('提交中，请稍后...');
        $.ajax({
            url: `https://${verification.productionUrl}.icolor.com.cn/htmlForm/signupForProfessionalDesigner`,
            type: "get",
            async: false,
            dataType: 'jsonp',
            data: {
                name: _name,
                company: _company,
                mobile: _phone,
                email: _email,
                city: _city,
                device: 'PC'
            },
            success: function(data) {
                let _state = data.success,
                    _msg = data.errorMsg;

                $('.form-btn').html('立即申请');
                if (_state) {
                    target.find('li').removeClass('active');
                    $("#popup-form").hide();
                    $('.form-list input').val('');
                    _this.lockScroll();
                    // 提交成功
                    new MsgBox({
                        iconCls: "ok",
                        msg: '恭喜您报名成功，<br>欢迎您加入高仪设计师俱乐部',
                        delay: 5
                    });
                } else {
                    // 提交失败
                    new MsgBox({
                        iconCls: "err",
                        msg: _msg,
                        delay: 5
                    });
                }
            }
        })
    }
}

//  弹窗组件
;(function() {
    let MsgBox = function(ops) {
        //  配置默认参数
        this.ops = {
            iconCls: null,
            msg: null,
            btns: null,
            delay: null,
            delayCallback: null
        };

        //  扩展默认参数
        if (ops && $.isPlainObject(ops)) {
            $.extend(this.ops, ops);
        }

        //  获取目标DOM
        this.body = $('body');
        this.msgbox = $('<div class="popup msgbox">');
        this.mask = $('<div class="popup msgbox-mask">');
        this.container = $('<div class="msgbox-container">');
        this.icon = $('<div class="msgbox-container-icon">');
        this.tips = $('<p class="msgbox-container-tips">');
        this.btnsBox = $('<div class="msgbox-container-btns">');

        //  生成DOM
        this.createDOM();
    };

    //  设置默认层级且多窗口时叠加
    MsgBox.zIndex = 999;

    MsgBox.prototype = {
        /*
         * 生成DOM
         * */
        createDOM: function() {
            let _this = this,
                ops = this.ops,
                body = this.body,
                mask = this.mask,
                msgbox = this.msgbox,
                container = this.container,
                icon = this.icon,
                tips = this.tips,
                btnsBox = this.btnsBox;

            //  自增层级，保证下次弹窗层级高于上次弹窗层级
            MsgBox.zIndex++;
            msgbox.css("zIndex", MsgBox.zIndex);

            //  图标增加class
            if (ops.iconCls) {
                icon.addClass(ops.iconCls);
                container.append(icon);
            }

            //  文字信息
            if (ops.msg) {
                container.append(tips.html(ops.msg));
            }

            //  定制按钮组
            if (ops.btns) {
                this.createBtn(btnsBox, ops.btns);
                container.append(btnsBox);
            }

            //  延迟关闭
            if (ops.delay) {
                setTimeout(function() {
                    _this.close();

                    //  如果有回调函数则执行
                    ops.delayCallback && ops.delayCallback();
                }, ops.delay * 1000)
            }

            msgbox.append(container);
            msgbox.append(mask);
            body.append(msgbox);

            mask.on("click", () => {
                _this.close();
            });
        },
        /*
         * 生成按钮
         * */
        createBtn: function(box, btns) {
            let _this = this;

            $(btns).each(function(i) {
                let text = this.text ? this.text : "按钮" + ++i,
                    cls = this.cls ? this.cls : "",
                    callback = this.callback ? this.callback : null,
                    btn = $('<a class="' + cls + '" href="javascript:;">' + text + '</a>');

                //  绑定事件
                btn.click(function() {
                    let isClose = callback && callback();

                    //  绑定事件不返回 false ，则默认关闭该弹窗
                    if (isClose != false) {
                        _this.close();
                    }
                });

                //  按钮生成
                _this.btnsBox.append(btn);
            });
        },
        /*
         * 移除窗口
         * */
        close: function() {
            this.msgbox.remove();
        }
    };

    //  注册MsgBox到window对象上
    window.MsgBox = MsgBox;
})();